import { FC } from "react";
import { useTranslation } from "react-i18next";
import ValidSVG from "../../resources/svg/functional/ValidSVG";
import LockIconSVG from "../../resources/svg/LockIconSVG";
import RatingStarSVG from "../../resources/svg/RatingStarIconSVG";

const SubscriptionAdvantagesSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center pt-[60px] pb-[100px] dmax2:pb-[60px]">
            <span className="H24B dmax2:H20B text-textWhite">{t("subscription.forWhatTitle")}</span>
            <div className="flex max-w-[550px] ti9:max-w-[440px] mt-10 mb-4">
                <ValidSVG className="min-w-8 h-8 mr-3" />
                <span className="H20B dmax2:H16B text-textWhite text-center">{t("subscription.forWhatArgument1")}</span>
            </div>
            <div className="flex flex-col max-w-[520px] ti9:max-w-[420px] tmax4:max-w-[360px]">
                <span className="H16 dmax2:H14 text-textFaded text-center mb-2">
                    {t("subscription.forWhatArgument2")}
                </span>
                <span className="H16 dmax2:H14 text-textFaded text-center mb-10">
                    {t("subscription.forWhatArgument3")}
                </span>
            </div>
            <div className="flex tmax5:flex-col-reverse gap-6 td3:gap-4 tmax5:gap-10">
                <div className="flex flex-col items-center">
                    <div className="flex flex-col items-center bg-[rgba(54,54,57,1)] border border-[rgba(45,45,50,1)] rounded-[16px] w-[519px] dmax2:w-[360px] h-[277px] dmax2:h-[218px] py-[52.5px] dmax2:py-[31px] px-5">
                        <LockIconSVG className="text-textFaded" />
                        <span className="H20B dmax2:H16B text-textWhite text-center max-w-[470px] mt-5 dmax2:mt-3">
                            {t("work.ordererClosed")}
                        </span>
                        <div className="button H16B dmax2:H14B text-textWhite h-[50px] dmax2:h-10 px-6 dmax2:px-4 pointer-events-none mt-5 dmax2:mt-3">
                            {t("main.callToSubscribeButton")}
                        </div>
                    </div>
                    <div className="flex items-center H16 dmax2:H14 text-textWhite bg-backgroundButton rounded-[30px] h-[33px] dmax2:h-[26px] px-[30px] dmax2:px-5 mt-4 dmax2:mt-3">
                        {t("subscription.withoutSubscription")}
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="flex flex-col bg-[rgba(45,45,50,1)] border border-[rgba(54,54,57,1)] rounded-[16px] w-[519px] dmax2:w-[360px] h-[277px] dmax2:h-[218px] py-6 dmax2:py-4 px-9 dmax2:px-5">
                        <span className="H24B dmax2:H20B text-textWhite text-start">{t("work.orderer")}</span>
                        <div className="flex items-center mt-6 dmax2:mt-4">
                            <div className="w-[70px] dmax2:w-[56px] h-[70px] dmax2:h-[56px] mr-4 dmax2:mr-3">
                                <img
                                    src="/images/client.png"
                                    alt="client"
                                    className="object-cover w-full h-full rounded-full"
                                />
                            </div>
                            <span className="H20B dmax2:H16B text-textWhite mr-4 dmax2:mr-2">Роман</span>
                            <div className="flex items-center">
                                <span className="H16B text-textWhite mr-1">5,0</span>
                                <RatingStarSVG className="w-[21px] text-textWarning mr-2" />
                                <span className="H16B text-textFaded">(12)</span>
                            </div>
                        </div>
                        <span className="H20B text-textWhite text-start mt-6 dmax2:mt-4">{t("common.contacts")}</span>
                        <div className="flex items-center justify-between mt-5 dmax2:mt-4">
                            <span className="H20B dmax2:H16B text-textWhite">+ 380 123 123 1234</span>
                            <div className="flex gap-4">
                                <img src="/images/telegram.png" alt="telegram" className="dmax2:w-8 dmax2:h-8" />
                                <img src="/images/viber.png" alt="viber" className="dmax2:w-8 dmax2:h-8" />
                                <img src="/images/whatsapp.png" alt="whatsapp" className="dmax2:w-8 dmax2:h-8" />
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center H16 dmax2:H14 text-textWhite bg-accentGreen rounded-[30px] h-[33px] dmax2:h-[26px] px-[30px] dmax2:px-5 mt-4 dmax2:mt-3">
                        {t("subscription.withSubscription")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionAdvantagesSection;
